













































import { Component, Vue } from "vue-property-decorator";
import MainButton from "@/main-components/common/MainButton.vue";

@Component({
  components: { MainButton },
})
export default class BlogBanner extends Vue {
  async bannerClick() {
    this.$sendMpEvent({
      event: this.$mp_value.CareerPath_view_click,
    });

    this.$router.push({ path: "/get-me-career-path" });
  }
}
